// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3RgXJ","content":"LayoutSettings_content__1699Z"};